import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";

const login = (phoneNumber, password, branchId) =>
  instance.post(apiUrls.LOGIN, {
    phoneMobile: phoneNumber,
    password: password,
    branch: branchId,
  });

const forgotPassword = (phoneMobile) =>
  instance.post(apiUrls.FORGOT_PASSWORD, { phoneMobile: phoneMobile });

const checkDuplicate = (phoneMobile, name, password, email, branchId) => {
  return instance.post(apiUrls.CHECK_DUPLICATE, {
    phoneMobile: phoneMobile,
    username: name,
    password: password,
    email: email,
    branch: branchId,
  });
};

const getResetPasswordToken = (token) => {
  return instance.get(`${apiUrls.RESET_PASSWORD}/${token}`);
};

const resetPassword = (token, phoneMobile, password) => {
  return instance.post(apiUrls.RESET_PASSWORD, {
    token: token,
    phoneMobile: phoneMobile,
    password: password,
  });
};

const checkDuplicateCustomerPhone = (phoneMobile, branchId) => {
  let apiURL = `${apiUrls.CHECK_DUPLICATE_CUSTOMER_PHONE}?published=1&phoneMobile=${encodeURIComponent(phoneMobile)}`;

  apiURL += branchId ? `&branch=${branchId}` : '';

  return instance.get(
    apiURL
  );
};

const register = (username, password, email, branch, phoneMobile) => {
  return instance.post(apiUrls.REGISTER, {
    username: username,
    password: password,
    email: email,
    branch: branch,
    phoneMobile: phoneMobile,
  });
};

const checkDuplicateCustomerSharedBranch = (branchId, phoneMobile) => {
  return instance.get(
    `${apiUrls.SEARCH_CUSTOMER
    }?branch=${branchId}&phoneMobile=${encodeURIComponent(phoneMobile)}`
  );
};

const updateEmail = (customerId, email) => {
  return instance.patch(`${apiUrls.UPDATE_EMAIL_CUSTOMER}/${customerId}`, {
    customerDetail: {
      email: email,
    },
  });
};

const requestOTP = (email) => {
  return instance.post(apiUrls.REQUEST_OTP, {
    email: email,
  });
};

const verifyOTP = (email, otp) => {
  return instance.post(apiUrls.VERIFY_OTP, {
    email: email,
    otp: otp,
  });
};

export {
  login,
  forgotPassword,
  resetPassword,
  getResetPasswordToken,
  checkDuplicate,
  checkDuplicateCustomerSharedBranch,
  register,
  requestOTP,
  updateEmail,
  checkDuplicateCustomerPhone,
  verifyOTP,
};
